import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ResourceEmpty } from "../../components/utils/ResourceEmpty";
import SearchQuery from "../../components/utils/SearchQuery";
import { getProductsAsync } from "../../slices/products";
import { ProductsCategoriesList } from "./category-list"
import { ProductsList } from "./list"


export const Parts = () => {
  const productState = useSelector((store) => {
    return store.products
  })

  const { isLoading, error, errors } = productState

  const products = productState.data
  const dispatch = useDispatch();
  const [controller, setController] = useState({
    filters: [
      { name: 'online_store', value: true },
      { name: 'status', value: 'active' },
      { name: 'hasSpareParts', value: true }
      // { name: 'categories', value: '44' }
    ],
    page: 1,
    per_page: 25,
    categories: '',
    query: '',
    sort: 'asc',
    sortBy: 'created_at',
    view: 'all',
  });


  const handleQueryChange = (newQuery) => {
    setController({
      ...controller,
      page: 1,
      query: newQuery
    });
  };

  // const handleCategorySelect = () => {
  //   setController({
  //     ...controller,
  //     filters: [
  //       ...controller.filters,
  //       { name: 'categories', value: selectedCategories }
  //     ]
  //   });
  // }


  const handlePageChange = (newPage) => {
    setController({
      ...controller,
      page: newPage
    });
  };


  useEffect(() => {
    const payload = {
      filters: controller.filters,
      page: controller.page,
      per_page: controller.per_page,
      query: controller.query,
      sort: controller.sort,
      sortBy: controller.sortBy,
      view: controller.view,
    }
    dispatch(getProductsAsync(payload));
  }, [dispatch, controller])





  return (
    <section className="sec" style={{ borderTop: "none" }}>
      <div className="wrap">
        <div
          style={{
            background: "var(--ink)",
            color: "#fff",
            borderRadius: 24,
            padding: "40px 44px",
            display: "grid",
            gridTemplateColumns: "1fr auto",
            gap: 24,
            alignItems: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div>
            <div className="sec-tag" style={{ color: "var(--airon)", marginBottom: 10 }}>
              Reservedeler
            </div>
            <h2
              style={{
                fontFamily: "var(--display)",
                fontSize: "clamp(24px, 2.8vw, 36px)",
                letterSpacing: "-0.02em",
                lineHeight: 1.1,
                fontWeight: 500,
                margin: "0 0 10px",
              }}
            >
              Finn reservedeler og tilbehør.
            </h2>
            <p style={{ color: "#B5C4D3", fontSize: 16, margin: 0 }}>
              Søk etter modellnavn eller artikkelnummer.
            </p>
          </div>
          <div style={{ width: "100%", maxWidth: 360 }}>
            <SearchQuery
              query={controller.query}
              onChange={handleQueryChange}
              label="Søk etter produkt"
              placeholder="Artikkelnummer eller navn"
            />
          </div>
        </div>

        <div style={{ marginTop: 32 }}>
          {products?.length > 0 ? (
            <ProductsList products={products} isLoading={isLoading} error={error} errors={errors} />
          ) : (
            <ResourceEmpty description="Vi fant dessverre ingen produkter med reservedeler. Prøv gjerne et annet søkeord eller ta kontakt med kundeservice." />
          )}
        </div>
      </div>
    </section>
  )
}